import { FormHelperText } from '@mui/material';
import React from 'react';
/**
 * Renders helper text and error messages for form fields, if provided.
 *
 * @param {FormHelperErrorDescriptionProps} props - Component props.
 * @param {string} [props.descriptionId] - The ID for the helper container element.
 * @param {string} [props.error] - Error message to display.
 * @param {string} [props.description] - Description text to display.
 * @returns {JSX.Element} A container with optional error and description helper text.
 */
export const FormHelperErrorDescription = ({ descriptionId, error, description }) => {
    return (React.createElement("div", { id: descriptionId },
        error && React.createElement(FormHelperText, { "data-test": 'error' }, error),
        description && (React.createElement(FormHelperText, { sx: { whiteSpace: 'pre-wrap' }, "data-test": 'description' }, description))));
};
